module.exports = __webpack_public_path__ + "static/media/Character1_TShirt.e193cd36.svg";